<template>
    <v-container fluid requests-status>
        <v-toolbar flat color="white">
            <v-toolbar-title>Журнал</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="info" dark class="mb-2" @click="getRequests">
                <i class="material-icons">
                refresh
                </i>  Обновить
            </v-btn>
            <v-flex xs6 sm3>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        class="table-search"
                        label="Поиск"
                        single-line
                        hide-details
                ></v-text-field>
            </v-flex>

        </v-toolbar>
        <v-data-table
                :headers="headers"
                :items="requests"
                :pagination.sync="pagination"
                :search="search"
                :loading="tableLoading"
                :light=true
                no-data-text=""
                rows-per-page-text="Строк на странице"
                :rows-per-page-items='[ 15, 30, 50, { "text": "все", "value": -1 } ]'
                class="elevation-1"
        >
            <template  slot="items" slot-scope="props">
                <td>
                    <v-tooltip top>
                        <v-btn slot="activator" flat icon :disabled="props.item.allRequestsCount == 0 ? true : false" @click="getCustomerAllRequests(props.item.customerId)">
                            {{ props.item.allRequestsCount }}
                        </v-btn>
                        <span v-if="props.item.allRequestsCount == 0">0 заявок  </span><span v-else>Открыть заявки</span>
                    </v-tooltip>
                </td>
                <td>
                    <v-tooltip top>
                        <v-btn slot="activator" flat icon :disabled="props.item.processedRequestsCount == 0 ? true : false" @click="getCustomerProcessedRequests(props.item.customerId)">
                            {{ props.item.processedRequestsCount }}
                        </v-btn>
                        <span v-if="props.item.processedRequestsCount == 0">0 заявок  </span><span v-else>Открыть заявки</span>
                    </v-tooltip>
                </td>
                <td>
                    <v-tooltip top>
                        <v-btn slot="activator" flat icon :disabled="props.item.newRequestsCount == 0 ? true : false" @click="getCustomerNewRequests(props.item.customerId)">
                            {{ props.item.newRequestsCount }}
                        </v-btn>
                        <span v-if="props.item.newRequestsCount == 0">0 заявок  </span><span v-else>Открыть заявки</span>
                    </v-tooltip>
                </td>
                <td>
                    <v-tooltip top>
                        <span slot="activator" :class="[props.item.allRequestsCount == 0 ? 'disabled' : 'active-customer']" @click="props.item.allRequestsCount != 0 ? getCustomerAllRequests(props.item.customerId) : ''">
                            {{ props.item.customerName }}
                        </span>
                        <span v-if="props.item.allRequestsCount == 0">0 заявок  </span><span v-else>Открыть заявки</span>
                    </v-tooltip>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                По вашему запросу "{{ search }}" ничего не найдено.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :total-visible="7" :length="pages"></v-pagination>
        </div>
    </v-container>
</template>

<script>
    import axios from 'axios'
    export default{
        data: () => ({
            backUrl: null,
            tableLoading: false,
            headers: [
                { text: 'Всего заявок', value: 'allRequestsCount'},
                { text: 'Заявки в работе', value: 'processedRequestsCount' },
                { text: 'Новые заявки', value: 'newRequestsCount' },
                { text: 'Заказчик', value: 'customerName'},
            ],
            requests: [],
            pagination: {},
            search: '',
            token:'',
            role:'',
        }),

        computed: {
            pages () {
                if (this.pagination.rowsPerPage == null ||
                    this.requests.length == null
                ) return 0
                return Math.ceil(this.requests.length / this.pagination.rowsPerPage)
            }

        },

        created () {
            this.token = localStorage.getItem('token');
            this.role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');

            this.getRequests();

        },

        methods: {

            getRequests(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/customers/stat',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    if(response.data) {
                        this.requests = response.data.data
                    }
                })
            },

            getCustomerAllRequests(id){
                this.$router.push({ name: 'requests', params: { requestType: 'allRequests' , id: id} })
            },

            getCustomerProcessedRequests(id){
                this.$router.push({name: 'requests', params: {requestType: 'allProcessedRequests', id: id}})
            },

            getCustomerNewRequests(id){
                this.$router.push({name: 'requests', params: {requestType: 'allNewRequests', id: id}})
            },
        }
    }
</script>
<style scoped>
    .active-customer{
        padding: 5px;
    }
    .active-customer:hover{
        background: #d4d2d2;
        cursor: pointer;
    }
    .disabled{
        padding: 5px;
        color: rgba(0,0,0,.26)!important;
    }
</style>
<style>
    .requests-status .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row){
        background:unset!important;
    }
</style>